<template>
  <div>
    <div id="stickyline"></div>

    <main>
      <slot />
    </main>

    <VFooter />
  </div>
</template>

<script>
export default {
  name: 'LayoutMinimal',

  components: {
    VFooter: () => import('@/components/UI/Footer'),
  },
};
</script>
